import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { useAnalystChatStore } from '~/components/ai/AnalystAgentPane/store/analystChatStore';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useSetAuthToken } from '~/hooks/useSetAuthToken';
import { useLocaleKeys } from '~/i18n';
import { useHomePage } from '~/pages/HomePage/HomePageProvider';
import { queryClient } from '~/queryClient';
export function useSwapAuthToken() {
    const history = useHistory();
    const { t: commonTexts } = useLocaleKeys('common');
    const { showErrorToast } = useOverlayContext();
    const { resetBusinessData } = useStoreActions();
    const setAuthToken = useSetAuthToken();
    const { setHidden } = useHomePage();
    return useCallback(async (authToken, options)=>{
        setHidden(true);
        resetBusinessData();
        useAnalystChatStore.getState().reset();
        try {
            await setAuthToken(authToken);
            queryClient.clear();
            history.replace((options === null || options === void 0 ? void 0 : options.route) || routes.home);
        } catch (unused) {
            showErrorToast(commonTexts.toasts.failedToSwitchBusiness(), 'swap-auth-token-failure');
            history.push(routes.logout);
        } finally{
            setHidden(false);
        }
    }, [
        commonTexts,
        history,
        resetBusinessData,
        setAuthToken,
        setHidden,
        showErrorToast
    ]);
}
